import React from 'react';
import { List, Datagrid, TextField, DateField, EditButton, RefreshButton,TextInput,Filter } from 'admin-on-rest';
import { CardActions } from 'material-ui/Card';

import { styles } from './styles';
import './index.css';

import IconTitle from '../components/icon_title';
import Pagination from '../components/pagination';

import {CustomerEdit as edit } from './Create';

const CustomerActions = ({ resource, basePath, refresh}) => (
  <CardActions style={styles.cardActionStyleSmall} className="customers-actions">
    <RefreshButton basePath={basePath} refresh={refresh}/>
  </CardActions>
);

const CustomersFilter=({ ...props })=>(
  <Filter {...props}>
    <TextInput
      label="resources.orders.actions.search"
      source="search"
      alwaysOn/>
  </Filter>
)

export const CustomerEdit = edit;
const FullNameField = ({ record = {} }) => <span>{record.first_name} {record.last_name}</span>;
export const CustomersList = (props) => (
  <List {...props} filters={<CustomersFilter />} actions={<CustomerActions />} title={<IconTitle icon="accounts" title={"resources.customers.title"} />} pagination={<Pagination  />}>
    <Datagrid bodyOptions={{  showRowHover: true }}>
      <FullNameField label="resources.customers.fieldList.name" source="first_name" />
      <TextField label="resources.customers.fieldList.email" source="email" />
      <DateField label="resources.customers.fieldList.create_at" source="created_at" />
      <EditButton label="" style={{ textAlign: 'right' }} />
    </Datagrid>
  </List>
);


// WEBPACK FOOTER //
// ./src/customers/index.js